module.exports = __webpack_public_path__ + "static/media/Administration.fabe1a28.gif";